import { render, staticRenderFns } from "./Planung.vue?vue&type=template&id=1535a59c&scoped=true"
import script from "./Planung.vue?vue&type=script&lang=ts"
export * from "./Planung.vue?vue&type=script&lang=ts"
import style0 from "./Planung.vue?vue&type=style&index=0&id=1535a59c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1535a59c",
  null
  
)

export default component.exports